<script>
import Layout from "@/views/layouts/main.vue";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";
import CommonTableComponent from "@/components/table.vue";
import tableSearch from "@/mixins/tableSearch";
import ModalHistory from "@/views/pages/project/schedule/modals/ModalHistory";
import ModalScheduleCar from "@/views/pages/project/schedule/modals/ModalScheduleCar";
import ModalScheduleStaff from "@/views/pages/project/schedule/modals/ModalScheduleStaff";
import ModalTransportTreatment from "@/views/pages/project/schedule/modals/ModalTransportTreatment.vue";
import WorkReservationSpecificDatesInformation
  from "@/views/pages/project/schedule/components/work_reservation_specific_dates_information.vue";
import apiEndpoints from "@/services/apiEndpoints";
import WorkOrderInformationComponent from "@/views/pages/project/schedule/components/work_order_information.vue";
import sweetAlert from "@/mixins/sweetAlert";
import number from "@/mixins/number";
import {mapState} from "vuex";
import systemCode from "@/mixins/systemCode";
import reservationTime from "@/mixins/reservationTime";
import moment from "moment-timezone";

const DEFAULT_EMPTY_SCHEDULE = (params) => {
  return {
    id: null,
    start_datetime: '',
    end_datetime: '',
    is_mixed_loading_kbn: 0,
    schedule_id_of_mixed_loading: '',
    waste_or_services_by_schedule: [],
    assigned_cars_by_schedule: [],
    assigned_staffs_by_schedule: [],
    ...params
  }
}
export default {
  components: {
    WorkOrderInformationComponent,
    Layout,
    DatePicker,
    Multiselect,
    CommonTableComponent,
    ModalHistory,
    ModalScheduleCar,
    ModalScheduleStaff,
    WorkReservationSpecificDatesInformation,
    ModalTransportTreatment,
  },
  mixins: [tableSearch, sweetAlert, number, systemCode, reservationTime],
  data() {
    return {
      workOrder: null,
      schedules: [],
      errors: {},
    };
  },
  async created() {
    //todo check role
    if (!this.workOrderId) {
      return this.$router.push({
        name: 'projects.schedules.register_by_work_order.select_waste_or_service',
      })
    }
    await this.getWorkOrder();
    this.addNewSchedule();
  },
  methods: {
    async getWorkOrder () {
      const {status, code, data} = await this.$http.get(apiEndpoints.detail_work_order(this.workOrderId))
      if (!status) {
        return this.errorToast(data.message);
      }
      this.workOrder = data.result;
    },
    onSelectedVehicles(data) {
      const indexSchedule = this.schedules.findIndex(x => x.id === data.currentSchedule.id);

      if (indexSchedule === -1) return;

      this.schedules[indexSchedule].assigned_cars_by_schedule = data.dataSelected;
    },
    onSelectedStaffs(data) {
      const indexSchedule = this.schedules.findIndex(x => x.id === data.currentSchedule.id);

      if (indexSchedule === -1) return;

      this.schedules[indexSchedule].assigned_staffs_by_schedule = data.dataSelected;
    },
    onSelectedTransportTreatment(data) {
      const indexSchedule = this.schedules.findIndex(x => x.id === data.scheduleInfo.schedule.id);
      if (indexSchedule === -1) return;
      const indexWasteOrService = this.schedules[indexSchedule].waste_or_services_by_schedule.findIndex(x => x.id === data.scheduleInfo.wasteOrServiceBySchedule.id);
      if (indexWasteOrService === -1) return;

      this.schedules[indexSchedule].waste_or_services_by_schedule[indexWasteOrService].disposal_sites_by_waste_id = data.id;
      this.schedules[indexSchedule].waste_or_services_by_schedule[indexWasteOrService].disposal_site = data.selectedItem;
    },
    removeAssignedCar(schedule, assigned_car) {
      const index = schedule.assigned_cars_by_schedule.findIndex(x => x.id === assigned_car.id);
      if (index === -1) return;

      schedule.assigned_cars_by_schedule.splice(index, 1);
    },
    removeAssignedStaff(schedule, assigned_staff) {
      const index = schedule.assigned_staffs_by_schedule.findIndex(x => x.id === assigned_staff.id);
      if (index === -1) return;

      schedule.assigned_staffs_by_schedule.splice(index, 1);
    },
    displayAssignedCar(assigned_car) {
      const carType = assigned_car.zz_car_type?.car_type;
      const carInfo = [assigned_car.area_name, assigned_car.classification_number, assigned_car.hiragana, assigned_car.number,].filter(x => !!x).join('－');

      return [
        carType,
        carInfo
      ].filter(x => !!x).join(' ');
    },
    displayWasteOrServiceName(waste_or_service_by_schedule) {
      const wasteOrService = waste_or_service_by_schedule.waste_or_service_by_work_order;

      if (wasteOrService.waste) {
        return wasteOrService.waste.name;
      }
      if (wasteOrService.service) {
        return wasteOrService.service.name;
      }

      return '';
    },
    displayWasteCategory(waste_or_service_by_schedule) {
      const wasteOrService = waste_or_service_by_schedule.waste_or_service_by_work_order;

      if (wasteOrService.waste) {
        return wasteOrService.waste?.waste_category?.name_abbreviated;
      }

      return '';
    },
    addNewSchedule() {
      const newSchedule = DEFAULT_EMPTY_SCHEDULE({
        zz_reservation_status_2_id: this.$constant.zz_reservation_status_2.currently_request_sub_contractor,
        new: true,
        id: this.$moment().unix(),
        is_mixed_loading_kbn: this.workOrder.mixed_loading_kbn === '2' ? 1 : 0,
      });
      let waste_or_services_by_schedule = [];
      const selectedWastesOrServicesIds = this.selectedWastesOrServicesByWorkOrder.map(x => x.id);
      this.workOrder.waste_or_service_by_work_order
        .filter(x => selectedWastesOrServicesIds.includes(x.id))
        .forEach(item => {
          let wasteOrServiceBySchedule = this.$_.cloneDeep(item);
          wasteOrServiceBySchedule.wastes_or_services_by_work_order_id = item.id;
          if (wasteOrServiceBySchedule.service_id) {
            //wasteOrServiceBySchedule.waste_estimates_by_schedule = [];
            //wasteOrServiceBySchedule.estimates = item.service.estimates;
            wasteOrServiceBySchedule.waste_estimates_by_schedule = wasteOrServiceBySchedule.service.estimates.map(x => {
              return {
                ...x,
                quantity: null,
                number_of_rental_containers: null,
              }
            });
          } else {
            wasteOrServiceBySchedule.waste_estimates_by_schedule = wasteOrServiceBySchedule.waste.estimates.map(x => {
              return {
                ...x,
                quantity: null,
                number_of_rental_containers: null,
              }
            })
          }
          wasteOrServiceBySchedule.waste_or_service_by_work_order = {...item};
          waste_or_services_by_schedule.push({...wasteOrServiceBySchedule})
        })

      newSchedule.waste_or_services_by_schedule = waste_or_services_by_schedule;
      newSchedule.start_datetime = this.reservationDate.date;
      newSchedule.end_datetime = this.reservationDate.date;
      const reservationStartTime = this.reservationDate.zz_day_of_time_zone_id.toString() === this.$constant.ZZ_DAY_OF_TIME_ZONE_ID_AM
        ? this.findReservationStartTimeAm().system_code_value || '09:00'
        : this.findReservationStartTimePm().system_code_value || '13:30';
      newSchedule.start_time = this.getReservationStartTime(reservationStartTime);
      newSchedule.end_time = this.getReservationEndTime(this.workOrder.standard_total_hours, newSchedule.start_time);
      newSchedule.zz_day_of_time_zone_id = this.reservationDate.zz_day_of_time_zone_id;

      this.schedules.unshift(newSchedule);
    },
    getDestinationWasteOrServiceBySchedule(wasteOrServiceBySchedule) {
      if (!wasteOrServiceBySchedule.disposal_site) return '';

      const vendorSite = wasteOrServiceBySchedule.disposal_site?.disposal_site_by_waste_category?.vendor_site_of_treatment?.name_abbreviated;
      const treatmentMethod = wasteOrServiceBySchedule.disposal_site?.disposal_site_by_waste_category?.zz_treatment_method?.treatment_method;

      return [vendorSite, treatmentMethod].filter(x => !!x).join('/');
    },
    openSelectAssignedCarsModal(schedule) {
      this.$refs.vehicleList.openModal(schedule);
    },
    openSelectAssignedStaffsModal(schedule) {
      this.$refs.staffList.openModal(schedule);
    },
    openSelectTransportTreatmentModal(wasteOrServiceBySchedule, schedule) {
      const waste_id = wasteOrServiceBySchedule.waste_or_service_by_work_order.waste_id;
      if (!waste_id) return;
      this.$refs.transportsTreatments.openModal({
        waste_id: waste_id,
        selectedScheduleInfo: {
          schedule,
          wasteOrServiceBySchedule
        },
      });
    },
    async onSubmit(onlyValidation = true) {
      this.errors = {};
      const schedules = this.$_.cloneDeep(this.schedules);

      if (this.workOrderId != this.$constant.work_order_type.work
           && this.workOrderId != this.$constant.work_order_type.others
      ) {
        // 作業分類：作業・その他以外では廃棄物見積明細のうち少なくとも1つは入力しているかチェック
        const schedule = schedules[0];

        for (let index = 0; index < schedule.waste_or_services_by_schedule.length; index++) {
          const wasteOrService = schedule.waste_or_services_by_schedule[index];

          // if (wasteOrService.type == 'service') {
          //   // サービスの場合は明細をチェックしない
          //   continue;
          // }

          const estimates = wasteOrService.waste_estimates_by_schedule;
          let sumQuantity = 0;

          estimates.forEach(estimate => {
            const quantity = estimate.quantity ? estimate.quantity : 0;
            sumQuantity += quantity;
          });

          if (sumQuantity === 0) {
            this.errors['schedules.0.waste_or_services_by_schedule.' + index + '.waste_estimates_by_schedule.quantity'] = ['少なくとも1つ数量を入力してください。'];
            return;
          }
        }


      }

      let params = {
        schedules: schedules,
        work_order_id: this.workOrderId,
        only_validation: onlyValidation,
      };

      const url = apiEndpoints.create_by_work_order(this.workOrderId)

      const {status, data, code} = await this.$http.post(url, params);

      if (status) {
        if (onlyValidation) {
          return this.handleConfirmUpdate();
        }
        this.successToast("登録が成功しました。", false, 2000);
        this.$router.push({
          name: 'schedule.car.list',
        });
      }

      if (this.$helpers.isDisplayFormError(code)) {
        this.errors = data.errors;
        if (this.errors['overlap_schedules'] && this.errors['overlap_schedules'].length) {
          this.handleOverlapSchedulesError(this.errors['overlap_schedules']);
        }
        return this.$nextTick(() => {
          this.scrollIntoError();
        });
      } else if (this.$helpers.isDisplayErrorInLocalComponent(code)) {
        return this.errorToast(data.message);
      }
    },
    handleConfirmUpdate() {
      this.confirm(
        '登録してよろしいですか？',
        '',
        '',
        'info',
        'OK',
        'キャンセル'
      ).then(async (result) => {
        if (result.isConfirmed) {
          await this.onSubmit(false);
        }
      });
    },
    handleOverlapSchedulesError(errors) {
      let message = [
        ...errors,
        'の車両に作業日時の重複があります。',
        '登録してよろしいですか？',
      ].join('<br>');
      this.confirm(
        '',
        '',
        message,
        'warning',
        'OK',
        'キャンセル'
      ).then(async (result) => {
        if (result.isConfirmed) {
          await this.onSubmit(false);
        }
      });
    },
    scrollIntoError() {
      const el = document.querySelector(".error-message");
      el.scrollIntoView({behavior: "smooth", block: "center", inline: "center"});
    },
    canUpdateZzReservationStatus2(schedule) {
      return !schedule.new && schedule.can_update_zz_reservation_status_2;
    },
    setMinNumber (e, number = 0) {
      if (e.target.value < number) e.target.value = number;
    },
  },
  computed: {
    ...mapState("schedule", ["temporary_selected_wastes_or_services"]),
    workOrderId() {
      return this.temporary_selected_wastes_or_services.work_order.id;
    },
    selectedWastesOrServicesByWorkOrder() {
      return this.temporary_selected_wastes_or_services.wastes_or_services_by_work_order;
    },
    reservationDate() {
      return this.temporary_selected_wastes_or_services.reservation_date;
    },
    zzReservationStatus2() {
      const options = this.$store.getters['options/options_tables'].zz_reservation_status_2 ?? [];
      return options.filter(option => option.id !== '0');
    },
    work_detail_header() {
      return [
        {
          text: "見積明細番号",
          value: "ID",
          sortable: false,
          width: 20
        },
        {
          text: "請求書表示用商品名",
          value: "name",
          sortable: false
        },
        {
          text: "予定数量",
          value: "quantity",
          sortable: false
        },
        {
          text: "単位",
          value: "unit",
          sortable: false
        },
        {
          text: "空容器数量（事前申込済のみ）",
          value: "empty_container_quantity",
          sortable: false
        }
      ];
    },
  },
  beforeDestroy() {
    this.$store.commit('schedule/RESET_SELECTED_WASTE_OR_SERVICE');
  },
};
</script>

<template>
  <Layout>
    <div class="scroll-area">
      <WorkOrderInformationComponent
        v-if="workOrder"
        :workOrder="workOrder"
      />
      <ModalScheduleCar
        ref="vehicleList"
        @dataSelected="onSelectedVehicles"
      />
      <ModalScheduleStaff
        ref="staffList"
        @dataSelected="onSelectedStaffs"
      />
      <ModalTransportTreatment
        ref="transportsTreatments"
        @dataSelected="onSelectedTransportTreatment"
      />
      <b-card
        v-for="(schedule, index) in schedules"
        class="reservation-reception"
        :key="`schedule_${schedule.id}`"
      >
        <div
          v-if="errors[`schedules.${index}`]"
          class="error-message"
        >
          {{ errors[`schedules.${index}`][0] }}
        </div>
        <b-row>
          <div class="title">■ 予約受付内容</div>
        </b-row>
        <b-row>
          <b-col cols="1">受付番号</b-col>
          <b-col class="d-flex gap-2">
            <span class="badge bg-primary">{{ schedule.zz_reservation_status1 ? schedule.zz_reservation_status1.reservation_status_1 : '' }}</span>
            <span class="badge bg-success">{{ schedule.zz_reservation_status2 ? schedule.zz_reservation_status2.reservation_status_2 : '' }}</span>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col cols="1 align-self-center">作業年月日</b-col>
          <b-col class="d-flex gap-2 col-4 align-items-baseline">
            <div>
              <date-picker
                v-model="schedule.start_datetime"
                lang="ja"
                placeholder="YYYY-MM-DD"
                format="YYYY-MM-DD"
                value-type="YYYY-MM-DD"
                position="left"
                :clearable="false"
                :editable="false"
              ></date-picker>
            </div>
            <div class="align-self-center">～</div>
            <div>
                <date-picker
                  v-model="schedule.end_datetime"
                  lang="ja"
                  placeholder="YYYY-MM-DD"
                  format="YYYY-MM-DD"
                  value-type="YYYY-MM-DD"
                  position="left"
                  :clearable="false"
                :editable="false"
                ></date-picker>
              </div>
          </b-col>
          <div
            v-if="errors[`schedules.${index}.start_datetime`]"
            class="error-message text-nowrap"
          >
            {{ errors[`schedules.${index}.start_datetime`][0] }}
          </div>
          <div
            v-if="errors[`schedules.${index}.end_datetime`]"
            class="error-message"
          >
            {{ errors[`schedules.${index}.end_datetime`][0] }}
          </div>
        </b-row>
        <b-row class="mt-2">
          <b-col cols="1 align-self-center">作業時間</b-col>
          <b-col class="d-flex gap-2 col-4 align-items-baseline">
            <div>
              <date-picker
                v-model="schedule.start_time"
                type="time"
                placeholder="HH:mm"
                format="HH:mm"
                value-type="HH:mm"
                position="left"
                :clearable="false"
                :editable="false"
              ></date-picker>
              <div
                v-if="errors[`schedules.${index}.start_time`]"
                class="error-message text-nowrap"
              >
                {{ errors[`schedules.${index}.start_time`][0] }}
              </div>
            </div>
            <div class="align-self-center">～</div>
            <div>
              <date-picker
                v-model="schedule.end_time"
                type="time"
                placeholder="HH:mm"
                format="HH:mm"
                value-type="HH:mm"
                position="left"
                :clearable="false"
                :editable="false"
              ></date-picker>
              <div
                v-if="errors[`schedules.${index}.end_time`]"
                class="error-message text-nowrap"
              >
                {{ errors[`schedules.${index}.end_time`][0] }}
              </div>
            </div>
          </b-col>
        </b-row>
        <b-button
          variant="primary mt-2"
          @click="openSelectAssignedCarsModal(schedule)"
        >
          <i class='far fa-list-alt'></i> 車両を選択する
        </b-button>
        <div class="selected-vehicles d-flex gap-2 mt-2 flex-wrap">
          <b-badge
            v-for="(assigned_car, indexCar) in schedule.assigned_cars_by_schedule"
            :key="`assigned_car_${schedule.id}_${assigned_car.id}`"
            variant="primary"
          >
            {{ displayAssignedCar(assigned_car) }}
            <span
              @click="removeAssignedCar(schedule, assigned_car)"
              class="badge badge-light badge-icon-custom"
            >×</span>
          </b-badge>
        </div>
        <b-button
          variant="primary mt-2"
          @click="openSelectAssignedStaffsModal(schedule)"
        >
          <i class='far fa-list-alt'></i> 従業員を選択する
        </b-button>
        <div class="selected-employees d-flex gap-3 mt-2">
          <b-badge
            v-for="(staff, indexStaff) in schedule.assigned_staffs_by_schedule"
            :key="`staff_${schedule.id}_${staff.id}`"
            variant="primary"
          >
            {{ staff.user_name }}
            <span
              @click="removeAssignedStaff(schedule, staff)"
              class="badge badge-light badge-icon-custom"
            >×</span>
          </b-badge>
        </div>
        <div class="custom-radio-group mt-3" v-if="canUpdateZzReservationStatus2(schedule)">
          <b-form-radio-group
            class="radio-group"
            :id="`zz_reservation_status_${index}`"
            text-field="reservation_status_2"
            value-field="id"
            v-model="schedule.zz_reservation_status_2_id"
            :options="zzReservationStatus2"
          ></b-form-radio-group>
        </div>
        <div class="d-flex gap-5 ml-2">
          <div class="d-flex gap-2">
            <div>合積</div>
            <b-form-checkbox
              :id="`is_mixed_loading_kbn${index}`"
              v-model="schedule.is_mixed_loading_kbn"
              :value="schedule.is_mixed_loading_kbn"
              :name="`is_mixed_loading_kbn${index}`"
              value="1"
              unchecked-value="0"
            >
              あり
            </b-form-checkbox>
          </div>
          <div class="d-flex gap-2">
            <div>合積受付番号</div>
            <div>
              <b-form-input
                type="number"
                v-model="schedule.schedule_id_of_mixed_loading"
              />
              <div
                v-if="errors[`schedules.${index}.schedule_id_of_mixed_loading`]"
                class="error-message"
              >
                {{ errors[`schedules.${index}.schedule_id_of_mixed_loading`][0] }}
              </div>
            </div>
          </div>
        </div>
        <div class="title mt-4">■ 作業内容</div>
        <div
          v-for="(waste_or_service_by_schedule, index_waste_or_service) in schedule.waste_or_services_by_schedule"
          :key="`waste_or_service_by_schedule_${schedule.id}_${waste_or_service_by_schedule.id}`"
          class="work-detail mt-2"
        >
          <div class="infomations d-flex gap-3">
            <div class="number">{{ index_waste_or_service + 1 }}.</div>
            <div class="waste-work-name">廃棄物・サービス名 <span>{{ displayWasteOrServiceName(waste_or_service_by_schedule) }}</span></div>
            <template v-if="waste_or_service_by_schedule && waste_or_service_by_schedule.waste_or_service_by_work_order.waste">
              <div class="waste-type">
                廃棄物種類
                <span>{{ displayWasteCategory(waste_or_service_by_schedule) }}</span>
              </div>
              <div class="manifesto d-flex gap-2">
                <p class="text-nowrap">マニフェスト</p>
                <div>
                  <b-form-input
                    @keyup="setMinNumber($event)"
                    v-model="waste_or_service_by_schedule.number_of_manifest"
                    type="number"
                    min="0"
                    />
                  <div
                    v-if="errors[`schedules.${index}.waste_or_services_by_schedule.${index_waste_or_service}.number_of_manifest`]"
                    class="error-message text-nowrap"
                  >
                    {{ errors[`schedules.${index}.waste_or_services_by_schedule.${index_waste_or_service}.number_of_manifest`][0] }}
                  </div>
                </div>
                <p>枚</p>
              </div>

            </template>
          </div>
          <template v-if="waste_or_service_by_schedule && waste_or_service_by_schedule.waste_or_service_by_work_order.waste">
            <div class="d-flex gap-2 transport-destination mt-2 align-items-center w-50">
              <div class="label text-nowrap">運搬先・処分方法</div>
              <b-form-input
                disabled
                :value="getDestinationWasteOrServiceBySchedule(waste_or_service_by_schedule)"
              ></b-form-input>
              <b-button
                @click="openSelectTransportTreatmentModal(waste_or_service_by_schedule, schedule)"
                variant="primary text-nowrap">
                変更
              </b-button>
            </div>
          </template>
          <div class="mt-3">
            <CommonTableComponent
              :height-class="`table-wrapper-500`"
            >
              <thead class="table-light">
              <tr>
                <th
                  v-for="(header, indexHeader) in work_detail_header"
                  :key="`table_wastes_or_services_by_work_reservation_header_${schedule.id}_${indexHeader}`"
                  :class="getHeaderClass(header)"
                >
                <span>
                  {{ header.text }}
                </span>
                </th>
              </tr>
              </thead>
              <tbody>
              <tr
                v-for="(waste_estimate_by_schedule, index_waste_estimates_by_schedule) in waste_or_service_by_schedule.waste_estimates_by_schedule"
                :key="`waste_estimate_by_schedule_${schedule.id}_${waste_or_service_by_schedule.id}_${waste_estimate_by_schedule.id}`"
              >
                <td>
                  {{ waste_estimate_by_schedule.estimate_cd }}
                </td>
                <td>
                  {{ waste_estimate_by_schedule.invoice_product_name }}
                </td>
                <td>
                  <b-form-input
                    @keyup="setMinNumber($event)"
                    :id="`waste_estimates_by_schedule_quantity_${waste_estimate_by_schedule.id}`"
                    type="number"
                    min="0"
                    v-model="waste_estimate_by_schedule.quantity"
                  ></b-form-input>
                  <div
                    v-if="errors[`schedules.${index}.waste_or_services_by_schedule.${index_waste_or_service}.waste_estimates_by_schedule.quantity`]"
                    class="error-message"
                  >
                    {{ errors[`schedules.${index}.waste_or_services_by_schedule.${index_waste_or_service}.waste_estimates_by_schedule.quantity`][0] }}
                  </div>
                  <div
                    v-if="errors[`schedules.${index}.waste_or_services_by_schedule.${index_waste_or_service}.waste_estimates_by_schedule.${index_waste_estimates_by_schedule}.quantity`]"
                    class="error-message"
                  >
                    {{ errors[`schedules.${index}.waste_or_services_by_schedule.${index_waste_or_service}.waste_estimates_by_schedule.${index_waste_estimates_by_schedule}.quantity`][0] }}
                  </div>
                </td>
                <td>
                  {{ waste_estimate_by_schedule.zz_unit.unit }}
                </td>
                <td>
                  <b-form-input
                    :disabled="!waste_or_service_by_schedule.waste_or_service_by_work_order.waste_id"
                    :id="`waste_estimates_by_schedule_number_of_rental_containers${waste_estimate_by_schedule.id}`"
                    type="text"
                    v-model="waste_estimate_by_schedule.number_of_rental_containers"
                  ></b-form-input>
                  <div
                    v-if="errors[`schedules.${index}.waste_or_services_by_schedule.${index_waste_or_service}.waste_estimates_by_schedule.${index_waste_estimates_by_schedule}`]"
                    class="error-message"
                  >
                    {{ errors[`schedules.${index}.waste_or_services_by_schedule.${index_waste_or_service}.waste_estimates_by_schedule.${index_waste_estimates_by_schedule}`][0] }}
                  </div>
                </td>
              </tr>
              <tr v-if="!waste_or_service_by_schedule.waste_estimates_by_schedule.length">
                <td colspan="6" class="text-center">
                  データなし。
                </td>
              </tr>
              </tbody>
            </CommonTableComponent>
          </div>
          <div class="mt-1">
            <label>事業者向け備考</label>
            <b-form-textarea
              rows="2"
              max-rows="6"
              v-model="waste_or_service_by_schedule.comment_to_discharger_site_user"
            ></b-form-textarea>
          </div>
          <div class="mt-1">
            <label>作業者向け備考</label>
            <b-form-textarea
              rows="2"
              max-rows="6"
              v-model="waste_or_service_by_schedule.comment_to_user"
            ></b-form-textarea>
          </div>
        </div>
      </b-card>
    </div>
    <div class="button-fixed-custom">
      <div class="list-button d-flex gap-2 justify-content-center">
        <b-button
          variant="primary"
          @click="onSubmit()"
        >
          <i class="fas fa-pencil-alt"></i> 登録
        </b-button>
        <router-link
          :to="{ path: $route.params.previousRoute.path }"
          tag="button"
          class="btn btn-primary waves-effect waves-light"
        >
          <i class='far fa-arrow-alt-circle-left'></i> {{ this.$lang.button.back }}
        </router-link>
      </div>
    </div>

  </Layout>
</template>

<style scoped lang="scss">
.scroll-area {
  max-height: calc(100vh - 150px);
  overflow-y: auto;
  overflow-x: hidden;
}
.work-instruction-content,
.reservation-contents,
.reservation-reception {
  .title {
    font-size: 16px;
    font-weight: 700;
  }
}
.work-instruction-content {
  .block-1,
  .block-2 {
    div > span {
      margin-left: 10px;
    }
  }
  .block-1 {
    a {
      text-decoration: underline !important;
      color: #495057;
    }
  }
  .block-3 {
    gap: 30px;
    .number-of-workers {
      margin-right: 20px;
      span {
        margin-left: 20px;
      }
    }
  }
  .block-4 {
    .vehicle-list {
      margin-left: 48px;
    }
  }
}
.reservation-contents {
  .block-1,
  .block-2 {
    div > span {
      margin-left: 10px;
    }
  }
  .block-5,
  .block-6 {
    span {
      margin-left: 10px;
    }
  }
}
.reservation-reception {
  .work-detail {
    .infomations {
      div > span {
        margin-left: 5px;
      }
      .waste-work-name {
        margin-left: 10px;
      }
      .waste-type, .manifesto {
        margin-left: 20px;
      }
    }
  }
  .transport-destination {
    margin-left: 35px;
  }
}
.badge {
  font-size: 14px;
  padding: 8px 16px;
  background-color: #14A5FD;
}
.badge.badge-icon-custom {
  color: #14A5FD;
  padding: 2px 6px;
  background-color: #f8f9fa;
  border-radius: 50%;
  font-weight: 700;
  cursor: pointer;
}
.custom-radio-group .radio-group {
  margin-left: unset;
}
.multiselect {
  width: 60%;
}
.button-fixed-custom {
  position: fixed;
  left: 50%;
  bottom: 0;
  z-index: 10;
  margin-bottom: 20px;
}
</style>
